import React, { useState, useEffect, useRef } from "react";
import { withRouter } from "react-router-dom";
import { useSnackbar } from "notistack";
import { useHistory } from "react-router-dom";
import { Table, TableBody, Paper, Grid } from "@material-ui/core";
import moment from "moment";
import JSZip from "jszip";
import { saveAs } from "file-saver";
import { AmpTaskForm, AmpList } from "../components";
import AmpHd from "../components/AmpHd";
import BasicDetailHeader from "../../BasicDetailHeader";
import { EmptyCollection, PageLoader, AccessDenied, DeletePopUp } from "../../../../shared_elements";
import { permissionCheckFnforCamo, downloadFileType, checkApiStatus } from "../../../../utils";
import { globalGetService, globalDeleteService, globalExportService } from "../../../../utils/globalApiServices";
import { trackActivity } from "../../../../utils/mixpanel";
import { assetType } from "../../../../constants";
import SubDetails from "../../../../shared_elements/components/sub_details/SubDetails";
import Pagination from "../../../../shared_elements/components/Pagination";
import ImportFileModule from "../../../../shared_elements/components/import_Format/ImportFileModule";
import CtaAction from "../../../../shared_elements/components/cta/CtaAction";

const AMPCompliance = ({ match }) => {
	const { enqueueSnackbar } = useSnackbar();
	const history = useHistory();

	const [pageLoader, setPageLoader] = useState(false);
	const [sortInfo, setSortInfo] = useState({ sort: '', sort_by: '' });
	const [filter, setFilter] = useState({});
	const [data, setData] = useState({ list: [], pagination: {}, new_task_last_used_folder_uuid: '', last_used_folder_uuid_link_document: '', checkbox_last_used_folder_uuid: '', checkbox_last_used_folder_name: '' });
	const [ampCRU, setAmpCRU] = useState({ modal: false, data: null, mode: '' });
	const [deleteList, setDeleteList] = useState({ modal: false, data: null });
	const [importFiles, setImportFiles] = useState({ modal: false });
	const [archiveModal, setArchiveModal] = useState(false);
	const [headerInfo, setHeaderInfo] = useState({ tsn: '', csn: '', dom: '', slug: '' });
	const [uuid, setUuid] = useState('');
	const [isBasicDetailExpanded, setIsBasicDetailExpanded] = useState(true);
	const [basicDetails, setBasicDetails] = useState({});

	const currentPerPageRef = useRef(250);

	useEffect(() => {
		trackActivity('AMP Page Visited - CAMO', { event_type: 'Page Visited', page_title: 'AMP Compliance' });
		getAMPList({ per_page: 250 });
	}, []);

	const getAMPList = (queryParams = {}, searchString = null) => {
		setPageLoader(true);
		const { asset, assetType: assetTypeParam } = match.params;
		globalGetService('camo/amp/list/', {
			...queryParams,
			per_page: queryParams.per_page || currentPerPageRef.current,
			asset,
			asset_type: assetTypeParam,
			search: searchString,
		}).then((response) => {
			setPageLoader(false);
			if (response.status === 500) {
				enqueueSnackbar("Something went wrong.", { variant: "error", anchorOrigin: { vertical: "top", horizontal: "right" } });
				return;
			}
			const { results, pagination } = response.data;
			const cleanFilter = { ...queryParams };
			delete cleanFilter.page;
			delete cleanFilter.per_page;
			delete cleanFilter.asset_type;
			delete cleanFilter.sort;
			delete cleanFilter.sort_by;
			setFilter(cleanFilter);
			setData(prev => ({
				...prev,
				list: results,
				pagination: {
					...prev.pagination,
					total: pagination.total,
					per_page: pagination.per_page,
					page: parseInt(pagination.current_page),
				},
				new_task_last_used_folder_uuid: response.data.new_task_last_used_folder_uuid,
				last_used_folder_uuid_link_document: response.data.last_used_folder_uuid_link_document,
				checkbox_last_used_folder_uuid: response.data.checkbox_last_used_folder_uuid,
				checkbox_last_used_folder_name: response.data.checkbox_last_used_folder_name,
			}));
		});
	};

	const createSortHandler = (sortField) => {
		if (sortField === "previous_taskCard") sortField = "previous_LDND_Taskcard";
		else if (sortField === "task_description") sortField = "Task_Description";
		const newSortBy = sortField === sortInfo.sort ? (sortInfo.sort_by === 'asc' ? 'desc' : 'asc') : 'asc';
		const newSortInfo = { sort: sortField, sort_by: newSortBy };
		setSortInfo(newSortInfo);
		getAMPList({ ...filter, ...newSortInfo, page: 1, per_page: data?.pagination?.per_page });
	};

	const deleteAmpRecord = () => {
		setPageLoader(true);
		globalDeleteService(`camo/amp/${deleteList.data.id}/delete/`).then((response) => {
			setPageLoader(false);
			setDeleteList({ modal: false, data: null });
			if (checkApiStatus(response)) {
				enqueueSnackbar("Record Deleted Successfully", { variant: "success", anchorOrigin: { vertical: "top", horizontal: "right" } });
				trackActivity('CAMO', { event_type: 'Item Deleted', page_title: 'AMP Compliance', item_id: deleteList.data?.id });
			} else {
				enqueueSnackbar("Something went wrong.", { variant: "error", anchorOrigin: { vertical: "top", horizontal: "right" } });
			}
			getAMPList({ per_page: currentPerPageRef.current });
		});
	};

	const exportAMPList = (extension) => {
		setPageLoader(true);
		const todayDate = moment(new Date()).format("YYYY-MM-DD");
		const { asset, assetType: assetTypeParam } = match.params;
		globalExportService(`/camo/amp/${asset}/${assetTypeParam}/export/`, { download: extension })
			.then((response) => {
				setPageLoader(false);
				if (checkApiStatus(response)) {
					downloadFileType(response.data, `${todayDate}_ESN ${basicDetails?.esn || basicDetails?.msn}_AMP`, extension);
					enqueueSnackbar("Download of AMP List successful", { variant: "success", anchorOrigin: { vertical: "top", horizontal: "right" } });
					trackActivity("CAMO", { event_type: "Item Exported", page_title: "AMP Listing", extension });
				} else {
					enqueueSnackbar("Something went wrong.", { variant: "error", anchorOrigin: { vertical: "top", horizontal: "right" } });
				}
			});
	};

	const downloadSampleFile = (extension) => {
		setPageLoader(true);
		globalExportService('camo/amp/sample-file/').then((response) => {
			setPageLoader(false);
			if (checkApiStatus(response)) {
				downloadFileType(response.data, 'SampleFile_AMP', extension);
				trackActivity("CAMO", { event_type: "Sample File Downloaded", page_title: "AMP Compliance", extension });
			} else {
				enqueueSnackbar("Something went wrong.", { variant: "error", anchorOrigin: { vertical: "top", horizontal: "right" } });
			}
		});
	};

	const downloadAllFiles = async (queryParams = {}) => {
		setPageLoader(true);
		const attachment_list = queryParams.item.download_attachments.map((entry) => [entry[0], decodeURIComponent(entry[1])]);
		const zip = new JSZip();
		const folder = zip.folder('DownloadedFiles');
		try {
			const downloadPromises = attachment_list.map(async (entry) => {
				const res = await fetch(entry[1] || '');
				if (!res.ok) throw new Error(`HTTP error! Status: ${res.status}`);
				const blob = await res.blob();
				folder.file(entry[0], blob);
			});
			await Promise.all(downloadPromises);
			const content = await zip.generateAsync({ type: 'blob' });
			saveAs(content, 'AMP.zip');
			setPageLoader(false);
		} catch (error) {
			console.error('Error:', error);
			setPageLoader(false);
		}
	};

	const archiveAsset = () => {
		const { assetType: assetTypeParam } = match.params;
		globalGetService(`console/archive-asset/${assetType[assetTypeParam]}/${headerInfo.slug}/true/`)
			.then(response => {
				if (checkApiStatus(response)) {
					enqueueSnackbar('Archive Status Updated Successfully', { variant: 'success', anchorOrigin: { horizontal: 'right', vertical: 'top' } });
					history.push("/assets-listing");
				} else {
					enqueueSnackbar(response?.data?.message, { variant: 'error', anchorOrigin: { horizontal: 'right', vertical: 'top' } });
				}
			});
	};

	const pullData = (slug, tsn, csn, dom) => {
		setHeaderInfo({ slug, tsn, csn, dom });
	};

	const uuidData = (uuidVal) => setUuid(uuidVal);

	return (
		<section className="amp-page">
			{pageLoader ? <PageLoader /> : null}
			<Grid style={{ marginTop: 0 }} spacing={3} container>
				<Grid style={{ paddingTop: 0, paddingRight: 0 }} xs={12} item>
					<SubDetails
					    masterExport={true}
						title="AMP/MRB Compliance"
						slug={headerInfo?.slug}
						match={match}
						onRefresh={() => getAMPList({ per_page: currentPerPageRef.current })}
						permissionCheck={permissionCheckFnforCamo({ primaryKey: "amp_compliance", keyIndex: "U" })}
					/>
					<BasicDetailHeader props={match} func={pullData} uuid={uuidData} module="amp" engineType={(data) => setBasicDetails(data)} onAccordionChange={setIsBasicDetailExpanded} />
					{permissionCheckFnforCamo({ primaryKey: "amp_compliance", keyIndex: "R" }) ? (
						<Paper square style={{ padding: "5px", marginTop: "10px" }} variant="outlined">
							<CtaAction
								searchPlaceholder="Search MPD Item no, Task Card no, Previous LDND TaskCard, Task Description"
								onSearch={(value) => getAMPList({ per_page: currentPerPageRef.current }, value)}
								permissionCheck={!permissionCheckFnforCamo({ primaryKey: "amp_compliance", keyIndex: "C" }) || window?.location?.search.includes('archived-assets')}
								addLabel="ADD AMP/MRB COMPLIANCE"
								onAddFn={() => setAmpCRU({ modal: true, data: null, mode: 'add' })}
								onImportFn={() => setImportFiles({ modal: true })}
								exportMenu={{
									exportReportFn: (file) => exportAMPList(file?.extension),
									files: [{ title: 'EXCEL', extension: 'xlsx' }, { title: 'PDF', extension: 'pdf' }],
									disabled: !data?.list?.length,
								}}
								downloadSampleMenu={{
									exportReportFn: (file) => downloadSampleFile(file?.extension),
									files: [{ title: 'DOWNLOAD SAMPLE', extension: 'xlsx', type: 'sample' }],
								}}
							/>
							<div style={{ height: `${window.innerHeight - (isBasicDetailExpanded ? 430 : 295)}px`, overflow: 'auto' }}>
								<Table className="mui-table-format" stickyHeader={true}>
									<AmpHd
										sortInfo={sortInfo}
										createSortHandler={createSortHandler}
									/>
									<TableBody>
										{data?.list?.map((item, index) => (
											<AmpList
												key={index}
												item={item}
												getResponseBack={() => getAMPList({ per_page: currentPerPageRef.current })}
												toggleModalFn={() => setAmpCRU({ modal: true, data: item, mode: 'edit' })}
												toggleDelteModalFn={() => setDeleteList({ modal: true, data: item })}
												downloadAllApi={(file) => downloadAllFiles({ item })}
											/>
										))}
									</TableBody>
								</Table>
								{!data?.list?.length ? <EmptyCollection title="No Records Found" /> : null}
							</div>
							<Pagination
								pagination={data?.pagination}
								onChangeRowsPerPage={(event) => {
									currentPerPageRef.current = event.target.value;
									getAMPList({ page: 1, per_page: event.target.value });
								}}
								onChangePage={(event, newPage) => getAMPList({ per_page: data.pagination.per_page, page: newPage + 1 })}
							/>
						</Paper>
					) : (
						<AccessDenied />
					)}
				</Grid>
			</Grid>

			{ampCRU?.modal ? (
				<AmpTaskForm
					modeType={ampCRU.mode}
					ampData={ampCRU.data}
					modalCloseFn={() => setAmpCRU({ modal: false, data: null, mode: '' })}
					getResponseBack={() => getAMPList({ per_page: currentPerPageRef.current })}
					headerTsn={headerInfo.tsn}
					headerCsn={headerInfo.csn}
					date_of_manufacture={headerInfo.dom}
					uuid={uuid}
					last_used_folder_uuid={data.new_task_last_used_folder_uuid}
					last_used_folder_uuid_link_document={data.last_used_folder_uuid_link_document}
					checkbox_last_used_folder_uuid={data.checkbox_last_used_folder_uuid}
					checkbox_last_used_folder_name={data.checkbox_last_used_folder_name}
				/>
			) : null}

			{deleteList?.modal ? (
				<DeletePopUp
					title="Delete AMP Record"
					deleteRecordFn={deleteAmpRecord}
					modal={true}
					content="Do you really want to delete this record?"
					toggleModalFn={() => setDeleteList({ modal: false, data: null })}
				/>
			) : null}

			{archiveModal && (
				<DeletePopUp
					title="Archive Asset"
					deleteRecordFn={archiveAsset}
					modal={true}
					content="Are you sure, you want to Archive?"
					toggleModalFn={() => setArchiveModal(false)}
					confirmText="ARCHIVE"
				/>
			)}

			{importFiles?.modal ? (
				<ImportFileModule
					importUrl={`camo/amp/${match?.params?.asset}/${match?.params?.assetType}/import/`}
					title="Import AMP Compliance"
					getResponseBack={() => getAMPList({ per_page: currentPerPageRef.current })}
					toggleModalFn={() => setImportFiles({ modal: false })}
				/>
			) : null}
		</section>
	);
};

export default withRouter(AMPCompliance);
